import find from "lodash-es/find";
import { mapGetters } from "vuex";
import * as types from "@/store/types";
import $thousandMask from "@/mixins/thousandMask";
import $exponent from "@/mixins/exponent";

export default {
  name: "price",
  components: {},
  props: ["price", "id"],
  mixins: [$exponent, $thousandMask],
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      markets: types.market.getters.GET_AVAILABLE_MARKET_DATA,
      defaultAsset: types.market.getters.GET_DEFAULT_TO_CURRENCY,
      baseId: types.market.getters.GET_SELECTED_BASE_CURRENCY,
      asset: types.market.getters.GET_TO_CURRENCY
    }),

    desCurrency() {
      let des = this.asset;
      if (Object.entries(des).length === 0) {
        des = this.defaultAsset;
      }
      return des;
    },

    market() {
      if (Object.entries(this.desCurrency).length !== 0) {
        return find(this.markets, {
          base_currency_id: this.baseId,
          asset_currency_id: this.id
        });
      }
    },
    baseExponent() {
      return this.market?.base_computational_exponent;
    },

    sellPrice() {
      const expo = this.$exponent(this.price, this.baseExponent);
      return this.$thousandMask(expo);
    }
  },
  mounted() {},
  methods: {}
};
